import script from "./ConfigScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigScreen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__